module.exports = __webpack_public_path__ + "static/logo-97a45855a53ac4da22ec2331968a2c05.png";